// @ts-strict-ignore
import type { InvestigationAgent } from '../types';
import type {
  InvestigationState,
  InvestigationsState,
} from './types';

export const initialInvestigationsState: InvestigationsState = {
  assignableAgents: [] as InvestigationAgent[],
  fetched: false,
  investigation: {} as InvestigationState,
  queue: {
    pagination: {
      totalInvestigations: 0,
      totalPages: 0,
      page: 0,
      perPage: 20,
    },
    sorting: {
      column: null,
      order: null,
    },
    error: null,
    filters: {
      actionedByAgents: [],
      assignedAgents: [],
      assignedAlertAgents: [],
      assignedInvestigationAgents: [],
      customers: [],
      programNames: [],
      entityNames: [],
      entityTypes: [],
      statuses: [],
      eventTypes: [],
      types: [],
      tagsAndOutcomeReasons: [],
      sources: [],
    },
    investigations: [],
    savedSearches: [],
  },
};
